import { mergeAttributes } from '@tiptap/core';
import Heading from '@tiptap/extension-heading';

export const CustomHeading = Heading.extend({
  renderHTML({ node, HTMLAttributes }) {
    const level: number = node.attrs.level;
    const headings: Record<number, string> = {
      1: 'text-display-large',
      2: 'text-display-medium',
      3: 'text-display-small',
      4: 'text-headline-large',
      5: 'text-headline-medium',
      6: 'text-headline-small',
    };
    const headingClass = headings[level] || 'text-headline-small';
    return [
      `div`,
      mergeAttributes(
        this.options.HTMLAttributes,
        HTMLAttributes,
        { class: headingClass },
      ),
      0,
    ];
  },
});
